// src/pages/SupportPage.jsx

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import {
    Container,
    Typography,
    TextField,
    Button,
    Box,
    Alert,
    AlertTitle,
    Link,
    Paper,
} from '@mui/material';
import * as Lucide from 'lucide-react';

export default function SupportPage() {
    const [message, setMessage] = useState('');
    const { tenant } = useParams();
    const { keycloak } = useKeycloak();
    const whatsappNumber = '55991261525'; // Apenas números

    const handleSubmit = (event) => {
        event.preventDefault();
        const userMessage = message.trim();

        if (!userMessage) {
            alert('Por favor, escreva sua mensagem.');
            return;
        }

        // Informações contextuais para ajudar o suporte
        const username =
            keycloak.tokenParsed?.preferred_username || 'Não identificado';
        const timestamp = new Date().toLocaleString('pt-BR', {
            dateStyle: 'short',
            timeStyle: 'short',
        });
        const currentPage = window.location.href;

        // ✅ CORREÇÃO: Monta a mensagem completa com quebras de linha normais (\n)
        const messageBody = `--- Solicitação de Suporte ---

*Usuário:* ${username}
*Tenant:* ${tenant || 'Não identificado'}
*Data/Hora:* ${timestamp}
*Página:* ${currentPage}

*Mensagem do Usuário:*
${userMessage}

--- Fim da Solicitação ---`;

        // ✅ CORREÇÃO: Codifica a string INTEIRA de uma só vez para garantir segurança e formatação.
        const encodedMessage = encodeURIComponent(messageBody);
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

        window.open(whatsappUrl, '_blank');
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 }, borderRadius: 2 }}>
                <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontWeight: 800,
                        color: 'text.primary',
                        letterSpacing: -0.5,
                        lineHeight: 1.2,
                        fontSize: { xs: '1.35rem', sm: '1.75rem', md: '2.125rem' },
                    }}
                >
                    Suporte via WhatsApp
                </Typography>
                <Typography variant="body1" align="center" sx={{ mb: 2 }}>
                    Número de Suporte:{' '}
                    <Link
                        href={`https://wa.me/${whatsappNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        fontWeight="bold"
                    >
                        +55 99126-1525
                    </Link>
                </Typography>

                <Alert severity="info" sx={{ mb: 3 }}>
                    <AlertTitle>Como funciona</AlertTitle>
                    Descreva sua dúvida ou problema abaixo. Ao clicar no botão,
                    sua mensagem será enviada para nossa equipe de suporte via
                    WhatsApp, junto com informações de contexto para nos ajudar
                    a atendê-lo mais rápido.
                </Alert>

                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        id="message"
                        label="Sua dúvida ou problema"
                        multiline
                        rows={6}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        variant="outlined"
                        fullWidth
                        required
                        sx={{ mb: 3 }}
                        placeholder="Descreva detalhadamente sua solicitação..."
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        startIcon={<Lucide.MessageCircle />}
                        fullWidth
                        sx={{
                            backgroundColor: '#25D366',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1DA851',
                            },
                            py: 1.5,
                            fontSize: '1rem',
                        }}
                    >
                        Enviar via WhatsApp
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
